var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editing)?_c('WikiEditor',{on:{"save":_vm.savePage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }